import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatService } from '../../services/chat.service';
import { Store } from '../../store';
import { GlobalSearchService } from '../global-search.service';
import { ChatRESTService } from 'src/app/chat/services/chat-rest.service';

@Component({
    selector: 'app-search-chats-view',
    templateUrl: './search-chats-view.component.html',
    styleUrls: ['./search-chats-view.component.scss'],
})
export class SearchChatsViewComponent implements OnInit, OnDestroy {
    params = { searchText: '' };
    isLoading$ = new BehaviorSubject(false);
    chats$ = new BehaviorSubject([]);
    destroy$ = new Subject<void>();
    selectedChatType: 'CUSTOMER_SERVICE' | 'YORKSTONE_CHAT' = 'CUSTOMER_SERVICE';
    customerChats = [];
    yorkstoneChats = [];

    get selectedChats() {
        const chats = this.selectedChatType === 'CUSTOMER_SERVICE' ? this.customerChats : this.yorkstoneChats;
        return chats.filter((c) => c.isClosed === 0);
    }

    get archiveCnt() {
        const chats = this.selectedChatType === 'CUSTOMER_SERVICE' ? this.customerChats : this.yorkstoneChats;
        return chats.filter((c) => c.isClosed === 1).length;
    }

    constructor(
        private store: Store,
        private router: Router,
        private chatService: ChatService,
        private chatRESTService: ChatRESTService,
        private searchService: GlobalSearchService
    ) {}

    ngOnInit(): void {
        this.searchService.searchStored$.pipe(takeUntil(this.destroy$)).subscribe((keyword: string) => {
            this.params = { searchText: keyword };
            this.search();
        });
    }
    search() {
        this.isLoading$.next(true);
        this.searchService.searchChats({ ...this.params }).subscribe(({ data }: any) => {
            this.customerChats = data.customerServices.groups;
            this.yorkstoneChats = data.ysAdmin.groups;

            if (!this.customerChats?.length && this.yorkstoneChats?.length) {
                this.selectedChatType = 'YORKSTONE_CHAT';
            }

            this.chats$.next(data.data);
            this.isLoading$.next(false);
        });
    }

    goToChat(group: any) {
        const chatStore = this.store.selectForLocal('chatStore');

        chatStore.group = group;

        chatStore.unread = 0;
        chatStore.groups.forEach((g) => {
            chatStore.unread = +chatStore.unread + +g.unread;
        });

        this.store.set('chatStore', chatStore);
        this.getByGroupId(group.id);
        this.forceNavigateTo([`/chat/${group.id}`]);
    }

    gotToArchive() {
        const chatStore = this.store.selectForLocal('chatStore');
        chatStore.archive = true;
        chatStore.group = undefined;
        this.forceNavigateTo(['/mail']);
    }

    getByGroupId(groupId) {
        this.chatService.getByGroupId(groupId).subscribe((data) => {
            this.markAsRead(groupId);
        });
    }
    markAsRead(groupId) {
        this.chatRESTService.markAsRead(groupId).subscribe();
    }
    forceNavigateTo(route: string[]) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(route));
    }

    selecteChatType(selectedChatType) {
        this.selectedChatType = selectedChatType;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
    }
}
